import { useState } from "react";
import { useActiveStories } from "@/hooks/useStories";
import { StoryCircle } from "./StoryCircle";
import { StoryViewer } from "./StoryViewer";

export function StoriesBar() {
  const { data: stories } = useActiveStories();
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);

  // Hide entirely if no active stories
  if (!stories || stories.length === 0) return null;

  return (
    <>
      <div className="w-full bg-background border-b border-border">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-3 py-3 overflow-x-auto scrollbar-hide">
            {stories.map((story, index) => (
              <StoryCircle
                key={story.id}
                story={story}
                onClick={() => setViewerIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>

      {viewerIndex !== null && (
        <StoryViewer
          stories={stories}
          initialIndex={viewerIndex}
          onClose={() => setViewerIndex(null)}
        />
      )}
    </>
  );
}
